import { createElement, type ComponentPropsWithRef, type JSX, type ReactElement } from 'react'

/** An element a kit component can render as. */
export type IntrinsicTag = keyof JSX.IntrinsicElements

/**
 * A kit component's props: its own, `as` for the element it renders, and every
 * prop that element takes except the ones the component owns. So the motion
 * goes on the element the markup already had, with no wrapper added around it.
 */
export type PolymorphicProps<T extends IntrinsicTag, Own> = Own & { as?: T } & Omit<
    ComponentPropsWithRef<T>,
    keyof Own | 'as'
  >

/**
 * Renders `tag` with `props`, typed loosely on purpose. The props were checked
 * against `as` at the call site; inside a kit component no single element type
 * can name them all, and JSX on a union of tags would intersect every tag's
 * handlers instead.
 */
export function renderAs(tag: IntrinsicTag, props: object): ReactElement {
  return createElement(tag, props)
}
